import { addMessages } from '@hana/i18n';

// Khoá chuỗi của tab Lịch dài hạn (LtsTab.tsx). Mã service, mã cảng, tên tàu và nhãn ô lưới (lts.ts) không dịch.
addMessages('vi', {
  'lt.allPorts': 'Tất cả cảng',
  'lt.w4': '4 tuần',
  'lt.w8': '8 tuần',
  'lt.lgOk': 'Có chuyến · ETD',
  'lt.lgNow': 'Tuần này',
  'lt.lgBlank': 'Blank sailing',
  'lt.lgEnd': 'Hết lịch',
  'lt.noWrite': 'Chưa bật ghi Services Map',
  'lt.blank': 'Blank sailing',
  'lt.blankSub': 'tuần trống giữa hai chuyến',
  'lt.delay': 'Đổi lịch',
  'lt.delaySub': 'Delay · ETD / Closing Change',
  'lt.vessel': 'Đổi tàu',
  'lt.vesselSub': 'thực tế khác lịch dài hạn',
  'lt.end': 'Hết lịch',
  'lt.endSub': 'cần nhập lịch hãng',
  'lt.sRan': 'Đã chạy',
  'lt.sDeclared': 'Đã khai',
  'lt.sNodata': 'Chưa có dữ liệu',
  'lt.delayN': 'Delay · {n} lần',
  'lt.added': 'Thêm {v}',
  'lt.carrier': 'Hãng',
  'lt.notice': 'Thông báo hãng',
  'lt.src': 'Nguồn',
  'lt.aSwap': 'Đổi tàu / chuyến',
  'lt.aMark': 'Đánh dấu blank sailing',
  'lt.aOpen': 'Mở service',
  'lt.aAdd': 'Thêm chuyến',
  'lt.aNotBlank': 'Không phải blank (thiếu dữ liệu)',
  'lt.aImport': 'Nhập lịch từ file hãng',
  'lt.detSub': '{code} · {name} · tại {vn} · tuần {w} từ {d}',
  'lt.title': 'Lịch dài hạn',
  'lt.polAria': 'Cảng xếp hàng',
  'lt.spanAria': 'Phạm vi',
  'lt.only': 'Chỉ service có thay đổi',
  'lt.noMatch': 'Không có service khớp',
  'lt.noMatchD': 'Bỏ bớt bộ lọc.',
  'lt.clear': 'Xoá lọc',
  'lt.gridAria': 'Lịch dài hạn theo tuần',
  'lt.colSvc': 'Service · cảng VN',
  'lt.thisWk': '{k} · tuần này',
  'lt.from': 'từ {d}',
  'lt.openSvc': 'Mở service {code}',
  'lt.detAria': 'Chi tiết chuyến',
  'lt.close': 'Đóng',
});
addMessages('en', {
  'lt.allPorts': 'All ports',
  'lt.w4': '4 weeks',
  'lt.w8': '8 weeks',
  'lt.lgOk': 'Sailing · ETD',
  'lt.lgNow': 'This week',
  'lt.lgBlank': 'Blank sailing',
  'lt.lgEnd': 'Schedule ended',
  'lt.noWrite': 'Writing Services Map is not enabled',
  'lt.blank': 'Blank sailing',
  'lt.blankSub': 'empty week between two sailings',
  'lt.delay': 'Schedule changes',
  'lt.delaySub': 'Delay · ETD / Closing Change',
  'lt.vessel': 'Vessel changes',
  'lt.vesselSub': 'actual differs from long-term schedule',
  'lt.end': 'Schedule ended',
  'lt.endSub': 'carrier schedule needed',
  'lt.sRan': 'Sailed',
  'lt.sDeclared': 'Declared',
  'lt.sNodata': 'No data',
  'lt.delayN': 'Delay · {n} times',
  'lt.added': 'Added {v}',
  'lt.carrier': 'Carrier',
  'lt.notice': 'Carrier notice',
  'lt.src': 'Source',
  'lt.aSwap': 'Change vessel / voyage',
  'lt.aMark': 'Mark blank sailing',
  'lt.aOpen': 'Open service',
  'lt.aAdd': 'Add sailing',
  'lt.aNotBlank': 'Not blank (missing data)',
  'lt.aImport': 'Import schedule from carrier file',
  'lt.detSub': '{code} · {name} · at {vn} · week {w} from {d}',
  'lt.title': 'Long-term schedule',
  'lt.polAria': 'Port of loading',
  'lt.spanAria': 'Range',
  'lt.only': 'Only services with changes',
  'lt.noMatch': 'No matching services',
  'lt.noMatchD': 'Remove some filters.',
  'lt.clear': 'Clear filters',
  'lt.gridAria': 'Long-term schedule by week',
  'lt.colSvc': 'Service · VN port',
  'lt.thisWk': '{k} · this week',
  'lt.from': 'from {d}',
  'lt.openSvc': 'Open service {code}',
  'lt.detAria': 'Sailing details',
  'lt.close': 'Close',
});
